import styled, { css } from 'styled-components';
import { Avatar, Box, BoxProps, inputMediumStyles } from '@bechtel/gds';
import { FC } from 'react';
import { SearchField } from '@bechtel/client-common';

export const AvatarRegularStyled = styled(Avatar)`
  height: 40px;
  width: 40px;
`;

export const CircleStyled = styled(Box).attrs({
  mx: { sm: '300' },
})`
  ${({ theme }) => css`
    width: ${theme.spacings[100]};
    height: ${theme.spacings[100]};
    background-color: ${theme.colors.grey[500]};
    border-radius: ${theme.radii[900]};
  `}
`;

interface CompletedCheckboxContainerProps extends BoxProps {
  disabled?: boolean;
  showBorder?: boolean;
}

export const CheckboxContainer = styled(Box as FC<CompletedCheckboxContainerProps>).attrs({
  py: { sm: '450' },
  px: { sm: '500' },
  alignItems: { sm: 'center' },
  gap: { sm: '400' },
})`
  ${({ disabled = false, theme }) =>
    disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
      clip-path: polygon(6% 0, 100% 0, 99% 100%, 0% 100%);
      background-color: ${theme.colors.grey[100]};
    `}
  cursor:pointer;
`;

export const WeldRow = styled(Box as FC<CompletedCheckboxContainerProps>).attrs({
  justifyContent: { sm: 'space-between' },
})`
  ${({ disabled = false, showBorder = false, theme }) =>
    css`
      ${disabled &&
        `opacity: 0.5;
          pointer-events: none;
          background-color: ${theme.colors.grey[100]};`}
      ${showBorder && `border-bottom: 1px solid ${theme.colors.grey['300']}`};
    `}
`;

export const SearchFieldComponentStyled = styled(SearchField)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[300]};
  `}
  ${inputMediumStyles}
`;
